import { ITableSetting } from "../../../../Table/BasicTable";
import { FeatureSet } from "../../../../../models/Offerings/featureSet";
import { IconWrapper } from "../../../ui-components/pageLayout/TableSettingsComponents";
import { MdModeEditOutline } from "react-icons/md";
import React from "react";

export const FeatureSetsPageSettings: ITableSetting<FeatureSet>[] = [
  {
    id: "name-id",
    align: "left",
    name: "NAME",
    path: "name",
    content: (data: FeatureSet) => <div>{data.name}</div>,
  },
  {
    id: "desc-id",
    align: "left",
    name: "DESCRIPTION",
    path: "description",
    content: (data: FeatureSet) => <div>{data.description}</div>,
  },
  {
    id: "enabled-id",
    align: "center",
    name: "ENABLED",
    path: "enabled",
    content: (data: FeatureSet) => (
      <input type="checkbox" readOnly checked={data.enabled} />
    ),
  },
  {
    id: "created-id",
    align: "left",
    name: "CREATED",
    path: "CREATED",
    content: (data: FeatureSet) => <div>{data.createdAt}</div>,
  },
  {
    id: "changed-id",
    align: "left",
    name: "CHANGED",
    path: "CHANGED",
    content: (data: FeatureSet) => <div>{data.updatedAt}</div>,
  },
  {
    id: "edit-id",
    align: "right",
    name: "",
    path: "gh",
    content: (data: FeatureSet) => (
      <IconWrapper>
        <MdModeEditOutline />
      </IconWrapper>
    ),
  },
];
